var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{nav:true, open: _vm.isMenuOpen}},[_c('tree',{ref:"menu",staticClass:"tree-highlights",attrs:{"data":_vm.course.nav,"options":_vm.menuOptions,"filter":_vm.menuFilter},on:{"node:expanded":_vm.onNodeExpand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }